/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RegisterWorkloadIssuerForm,
  RegisterWorkloadIssuerForm$Outbound,
  RegisterWorkloadIssuerForm$outboundSchema,
} from "../components/registerworkloadissuerform.js";

export type RegisterWorkloadIssuerSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type RegisterWorkloadIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RegisterWorkloadIssuerSecurity = {
  option1?: RegisterWorkloadIssuerSecurityOption1 | undefined;
  option2?: RegisterWorkloadIssuerSecurityOption2 | undefined;
};

export type RegisterWorkloadIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  registerWorkloadIssuerForm: RegisterWorkloadIssuerForm;
};

/** @internal */
export type RegisterWorkloadIssuerSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const RegisterWorkloadIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RegisterWorkloadIssuerSecurityOption1$Outbound,
    RegisterWorkloadIssuerSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function registerWorkloadIssuerSecurityOption1ToJSON(
  registerWorkloadIssuerSecurityOption1: RegisterWorkloadIssuerSecurityOption1,
): string {
  return JSON.stringify(
    RegisterWorkloadIssuerSecurityOption1$outboundSchema.parse(
      registerWorkloadIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type RegisterWorkloadIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RegisterWorkloadIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RegisterWorkloadIssuerSecurityOption2$Outbound,
    RegisterWorkloadIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function registerWorkloadIssuerSecurityOption2ToJSON(
  registerWorkloadIssuerSecurityOption2: RegisterWorkloadIssuerSecurityOption2,
): string {
  return JSON.stringify(
    RegisterWorkloadIssuerSecurityOption2$outboundSchema.parse(
      registerWorkloadIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type RegisterWorkloadIssuerSecurity$Outbound = {
  Option1?: RegisterWorkloadIssuerSecurityOption1$Outbound | undefined;
  Option2?: RegisterWorkloadIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RegisterWorkloadIssuerSecurity$outboundSchema: z.ZodMiniType<
  RegisterWorkloadIssuerSecurity$Outbound,
  RegisterWorkloadIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RegisterWorkloadIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RegisterWorkloadIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function registerWorkloadIssuerSecurityToJSON(
  registerWorkloadIssuerSecurity: RegisterWorkloadIssuerSecurity,
): string {
  return JSON.stringify(
    RegisterWorkloadIssuerSecurity$outboundSchema.parse(
      registerWorkloadIssuerSecurity,
    ),
  );
}

/** @internal */
export type RegisterWorkloadIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RegisterWorkloadIssuerForm: RegisterWorkloadIssuerForm$Outbound;
};

/** @internal */
export const RegisterWorkloadIssuerRequest$outboundSchema: z.ZodMiniType<
  RegisterWorkloadIssuerRequest$Outbound,
  RegisterWorkloadIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    registerWorkloadIssuerForm: RegisterWorkloadIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      registerWorkloadIssuerForm: "RegisterWorkloadIssuerForm",
    });
  }),
);

export function registerWorkloadIssuerRequestToJSON(
  registerWorkloadIssuerRequest: RegisterWorkloadIssuerRequest,
): string {
  return JSON.stringify(
    RegisterWorkloadIssuerRequest$outboundSchema.parse(
      registerWorkloadIssuerRequest,
    ),
  );
}
